/**
 * Converts a date to UTC start of day (00:00:00.000Z), preserving the calendar date.
 * Use this when the date picker gives a local date and you need the same calendar date in UTC.
 *
 * Example: User selects "Jan 2" in IST timezone
 * - Input: Jan 2, 2026 00:00:00 IST (local Date object)
 * - Output: "2026-01-02T00:00:00.000Z" (Jan 2 at midnight UTC)
 */
export function toUTCStartOfDay(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(Date.UTC(year, month, day, 0, 0, 0, 0)).toISOString();
}

/**
 * Converts a date to UTC end of day (23:59:59.999Z), preserving the calendar date.
 * Use this when the date picker gives a local date and you need the same calendar date in UTC.
 *
 * Example: User selects "Jan 4" in IST timezone
 * - Input: Jan 4, 2026 00:00:00 IST (local Date object)
 * - Output: "2026-01-04T23:59:59.999Z" (Jan 4 at end of day UTC)
 */
export function toUTCEndOfDay(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(Date.UTC(year, month, day, 23, 59, 59, 999)).toISOString();
}
